import { supabase } from '../client/supabaseClient';

export interface ShopPricing {
    shop_id: string;
    shop_name: string;
    paper_type: string;
    monochrome_cost: number;
    color_cost: number;
    monochrome_min_cost: number;
    color_min_cost: number;
}

/**
 * Fetches the pricing information for a specific print shop from the database.
 * Calls the 'fetch_shop_pricing' RPC in the 'api' schema.
 * 
 * @param shopId The UUID of the print shop
 * @param paperType The paper type (A4, A3, Letter, Legal) - defaults to A4
 * @returns The shop pricing information or null if not found
 */
export async function fetchShopPricing(shopId: string, paperType: string = 'A4'): Promise<ShopPricing | null> {
    try {
        const { data, error } = await supabase
            .schema('api')
            .rpc('fetch_shop_pricing', {
                p_shop_id: shopId,
                p_paper_type: paperType
            });

        if (error) {
            console.error('Error fetching shop pricing:', error);
            return null;
        }

        if (!data || data.length === 0) {
            console.warn('No pricing data found for shop ID:', shopId);
            return null;
        }

        return data[0] as ShopPricing;
    } catch (error) {
        console.error('Unexpected error in fetchShopPricing:', error);
        return null;
    }
}
